import React from 'react';
import { Atom, Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-slate-900 text-slate-300 py-12 border-t border-slate-800" data-id="element-92">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-93">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-94">
          <div className="col-span-1 md:col-span-2" data-id="element-95">
            <div className="flex items-center space-x-2 text-white font-bold text-xl tracking-tight mb-4" data-id="element-96">
              <Atom className="h-6 w-6 text-indigo-500" data-id="element-97" />
              <span data-id="element-98">Atomic Team Design</span>
            </div>
            <p className="text-slate-400 max-w-xs leading-relaxed" data-id="element-99">
              Science-inspired organisational design for modern engineering
              teams. Build structure that scales.
            </p>
          </div>

          <div data-id="element-100">
            <h4 className="text-white font-semibold mb-4" data-id="element-101">Resources</h4>
            <ul className="space-y-2" data-id="element-102">
              <li data-id="element-103">
                <button onClick={() => scrollToSection('concepts')} className="hover:text-white transition-colors" data-id="element-104">
                  Concepts
                </button>
              </li>
              <li data-id="element-105">
                <button onClick={() => scrollToSection('manifesto')} className="hover:text-white transition-colors" data-id="element-106">
                  Manifesto
                </button>
              </li>
              <li data-id="element-107">
                <button onClick={() => scrollToSection('getting-started')} className="hover:text-white transition-colors" data-id="element-108">
                  Getting Started
                </button>
              </li>
              <li data-id="element-109">
                <button onClick={() => scrollToSection('platform')} className="hover:text-white transition-colors" data-id="element-110">
                  Platform
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-111">
            <h4 className="text-white font-semibold mb-4" data-id="element-112">Connect</h4>
            <div className="flex space-x-4" data-id="element-113">
              <a href="#" className="hover:text-white transition-colors" aria-label="Twitter" data-id="element-114">
                <Twitter className="h-5 w-5" data-id="element-115" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-116">
                <Linkedin className="h-5 w-5" data-id="element-117" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="GitHub" data-id="element-118">
                <Github className="h-5 w-5" data-id="element-119" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500" data-id="element-120">
          <p data-id="element-121">© 2026 Atomic Team Design. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-122">
            <a href="#" className="hover:text-slate-300" data-id="element-123">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-300" data-id="element-124">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}